module.exports = __webpack_public_path__ + "img/food1.89a32b04.jpg";